import {addDays} from 'date-fns';
import {
    AndFilter,
    CheckboxFilterClient,
    DateFilter,
    FieldFilter,
    FilterClient,
    FilterGroup,
    NotFilter,
    OrFilter
} from './filter';

export enum tagsFilters {
    date = 'date',
    kommener = 'kommener',
}

export const tilDatoActiveFilter = OrFilter.create(
    FieldFilter.create('TilDato', 'Equal', null),
    DateFilter.create('TilDato', 'GreaterThanOrEqual', addDays(new Date(), 1))
);

export const tilDatoAvsluttedeFilter = AndFilter.create(
    FieldFilter.create('TilDato', 'NotEqual', null),
    DateFilter.create('TilDato', 'LessThanOrEqual', new Date())
);
export const undergraderingFilter = FieldFilter.create('ErUnderGradering', 'Equal', false);
export const notUndergraderingFilter = FieldFilter.create('ErUnderGradering', 'Equal', true);

export const isJaVedriFilter = FieldFilter.create('verdi', 'Equal', 'ja') as FieldFilter;


export const activeTillDataFilter: FilterClient = {
    label: 'Vis bare aktive',
    selected: true,
    filter: tilDatoActiveFilter
};


export const identityFilter = AndFilter.create(tilDatoActiveFilter,
    OrFilter.create(FieldFilter.create('KategoriId', 'Equal', '3'),
        FieldFilter.create('KategoriId', 'Equal', '5')
    ));

export const activeTillTreeDataFilter: FilterClient = {
    label: 'Vis bare aktive',
    selected: true,
    filter: tilDatoActiveFilter
};
// export const avsluttedeTillTreeDataFilter: FilterClient = {
//     label: 'Vis avsluttede',
//     selected: false,
//     filter: tilDatoAvsluttedeFilter
// };

export const visBareDeaktiverteTilleggsdataFilter: FilterClient = {
    label: 'Vis bare deaktiverte tilleggsdata',
    selected: false,
    filter: FieldFilter.create('Deaktivert', 'Equal', true)
};

export const visBareAktiveTilleggsdataFilter: FilterClient = {
    label: 'Vis bare aktive tilleggsdata',
    selected: true,
    filter: FieldFilter.create('Deaktivert', 'NotEqual', true)
};

export const deaktiverteTilleggsdataFilters: FilterGroup[] = [{
    set: [
        visBareDeaktiverteTilleggsdataFilter,
        visBareAktiveTilleggsdataFilter,
    ],
    multiple: false,
    includeAlle: true
}];

export const erUnderGraderingFilter = {
    label: 'Vis undergradering',
    selected: true,
    asCheckbox: true,
    oppositeFilter: undergraderingFilter,
    filter: OrFilter.combine([undergraderingFilter, notUndergraderingFilter])
};

export const avsluttedeTillDataFilter: FilterClient = {
    label: 'Vis bare avsluttede',
    selected: false,
    filter: tilDatoAvsluttedeFilter
};

export const norskeFilter: FilterClient = {
    label: 'Vis bare norske',
    selected: false,
    filter: FieldFilter.create('Land.Id', 'Equal', 'NO')
};

export const dateFilters: FilterGroup[] = [{
    set: [
        activeTillDataFilter,
        avsluttedeTillDataFilter,
    ],
    multiple: false,
    includeAlle: true
}];


export const dateTreeFilters: FilterGroup[] = [{
    set: [
        activeTillTreeDataFilter,
       // avsluttedeTillTreeDataFilter,
    ],
    multiple: false,
    includeAlle: true
}];


export function isCheckboxFilter(object: any): object is CheckboxFilterClient {
    return 'asCheckbox' in object;
}

export const getEqualFieldListValuesFilter = (field: string, valueList: string[] | number[]) => {
    if (valueList.length > 0) {
        return FieldFilter.create(field, 'InArray', valueList);
    } else return FieldFilter.create(field, 'Equal', '');
};

export const getNotEqualFieldListValuesFilter = (field: string, valueList: string[] | number[]) => {
    if (valueList.length > 0) {
        return NotFilter.create(FieldFilter.create(field, 'InArray', valueList));
    } else return FieldFilter.create(field, 'NotEqual', '');
};

